import React, { useState } from 'react';
import { FaCloudUploadAlt } from 'react-icons/fa';

const FileDropper = ({ onUpload, isUploading, children }) => {
  const [isDragActive, setIsDragActive] = useState(false);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setIsDragActive(true);
    } else if (e.type === "dragleave") {
      setIsDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      onUpload(e.dataTransfer.files);
    }
  };

  return (
    <div 
      onDragEnter={handleDrag} 
      onDragLeave={handleDrag} 
      onDragOver={handleDrag} 
      onDrop={handleDrop}
      className={`relative min-h-[400px] rounded-3xl transition-all ${
        isDragActive ? 'bg-blue-50/50 ring-4 ring-blue-400 ring-dashed' : ''
      }`}
    >
      {isDragActive && (
        <div className="absolute inset-0 z-50 flex flex-col items-center justify-center bg-blue-600/90 rounded-3xl text-white backdrop-blur-sm">
          <FaCloudUploadAlt className="text-6xl mb-4 animate-bounce" />
          <h2 className="text-2xl font-black uppercase">Drop to Upload</h2>
          <p className="font-bold opacity-75">Files will be sorted alphanumerically</p>
        </div>
      )}
      
      {children}
    </div>
  );
};

export default FileDropper;